import { useState, useEffect, useRef } from 'react'
import toast from 'react-hot-toast'
import { MODOS, INFO_MODO, modoActual, cambiarModo } from '../../lib/modoPantalla'

const TRAZOS = {
  dia: 'M12 4v1.5m0 13V20M6.3 6.3l1 1m9.4 9.4l1 1M4 12h1.5m13 0H20M6.3 17.7l1-1m9.4-9.4l1-1M15.5 12a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z',
  sol: 'M12 2.5v3m0 13v3M4.6 4.6l2.1 2.1m10.6 10.6l2.1 2.1M2.5 12h3m13 0h3M4.6 19.4l2.1-2.1m10.6-10.6l2.1-2.1M16 12a4 4 0 11-8 0 4 4 0 018 0z',
  noche: 'M20.4 14.3A8.5 8.5 0 019.7 3.6a8.5 8.5 0 1010.7 10.7z',
}

const IconoModo = ({ modo, className = 'h-5 w-5' }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d={TRAZOS[modo]} />
  </svg>
)

// 'light' = sobre fondo de color (header móvil), 'dark' = sobre fondo blanco (topbar desktop).
const ModoPantallaBoton = ({ tone = 'light' }) => {
  const [modo, setModo] = useState(modoActual)
  const [abierto, setAbierto] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!abierto) return
    const alClickAfuera = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setAbierto(false)
    }
    const alEscape = (e) => e.key === 'Escape' && setAbierto(false)
    document.addEventListener('mousedown', alClickAfuera)
    document.addEventListener('keydown', alEscape)
    return () => {
      document.removeEventListener('mousedown', alClickAfuera)
      document.removeEventListener('keydown', alEscape)
    }
  }, [abierto])

  const elegir = (m) => {
    setModo(cambiarModo(m))
    setAbierto(false)
    toast.success(INFO_MODO[m].nombre, { icon: '🖥️' })
  }

  const base =
    tone === 'dark'
      ? 'text-slate-500 hover:text-slate-900 hover:bg-slate-100'
      : 'text-white/90 hover:text-white hover:bg-white/10'
  const resalte =
    modo === 'sol' ? 'text-warning-dark bg-warning-soft/60 hover:bg-warning-soft'
    : modo === 'noche' ? 'text-indigo-300 bg-indigo-500/20 hover:bg-indigo-500/30'
    : base

  return (
    <div className="relative flex-shrink-0" ref={ref}>
      <button
        type="button"
        onClick={() => setAbierto((v) => !v)}
        aria-expanded={abierto}
        aria-haspopup="menu"
        title={`Pantalla: ${INFO_MODO[modo].nombre}`}
        aria-label={`Modo de pantalla: ${INFO_MODO[modo].nombre}. Tocá para elegir otro.`}
        className={`p-2 rounded-lg transition-colors ${resalte}`}
      >
        <IconoModo modo={modo} />
      </button>

      {abierto && (
        <div role="menu" className="absolute right-0 mt-2 w-[min(88vw,17rem)] card p-1.5 shadow-card-hover z-40">
          <p className="label px-2.5 pt-1.5 pb-1 mb-0">Pantalla</p>
          {MODOS.map((m) => {
            const elegido = m === modo
            return (
              <button
                key={m}
                type="button"
                role="menuitemradio"
                aria-checked={elegido}
                onClick={() => elegir(m)}
                className={`w-full text-left px-2.5 py-2 rounded-lg flex items-start gap-2.5 transition-colors ${
                  elegido ? 'bg-social-700/10' : 'hover:bg-black/[0.04]'
                }`}
              >
                <span className={`mt-0.5 flex-shrink-0 ${elegido ? 'text-social-700' : 'text-ink-soft'}`}>
                  <IconoModo modo={m} className="h-[18px] w-[18px]" />
                </span>
                <span className="min-w-0 flex-1">
                  <span className={`block text-sm font-bold ${elegido ? 'text-social-700' : 'text-ink'}`}>
                    {INFO_MODO[m].nombre}
                  </span>
                  <span className="block text-[11px] text-ink-soft leading-snug">{INFO_MODO[m].detalle}</span>
                </span>
                {elegido && (
                  <svg className="h-4 w-4 text-social-700 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default ModoPantallaBoton
